import { MiModal } from "@miplatform/components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@miplatform/constants";
import { ICategoryDropsResponse } from "@miplatform/types";
import { useTheme } from "@mui/material";

export function DeleteCategoryDropModal({
  open,
  selectedDrop,
  handleDeleteCategoryDrop,
  categoryId,
  closeModal,
}: DeleteCategoryDropModalProps) {
  const theme = useTheme();

  return (
    <MiModal
      open={open}
      closeModal={closeModal}
      title="Delete Drop Type?"
      description={
        <>
          Are you sure you want to delete{" "}
          <span
            style={{
              fontWeight: theme.fontWeight.semiBold,
              color: theme.palette.primary.main,
            }}
          >
            {selectedDrop?.name}
          </span>{" "}
          drop type? This will remove this drop type from all price levels. This
          action cannot be undone.
        </>
      }
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: closeModal,
        },
        {
          name: "Yes",
          variant: BUTTON_VARIANTS.CONTAINED,
          color: BUTTON_COLORS.PRIMARY,
          onClick: () => {
            if (selectedDrop) {
              handleDeleteCategoryDrop(categoryId, selectedDrop);
            }
            closeModal();
          },
        },
      ]}
    />
  );
}

interface DeleteCategoryDropModalProps {
  open: boolean;
  selectedDrop: ICategoryDropsResponse | null;
  handleDeleteCategoryDrop: (
    categoryId: string,
    data: Partial<ICategoryDropsResponse>
  ) => void;
  categoryId: string;
  closeModal: () => void;
}
